import { FC } from 'react'
import { useMedia } from 'react-use'
import { LaunchScreen } from '@getgo/chameleon-web-react-wrapper'
import { ThemeProvider as ChamWebThemeProvider } from '@getgo/chameleon-web-react-wrapper'
import { useLocalStorage } from '@rehooks/local-storage'
import { ChameleonSkin } from '@ucc/unified-admin-common'

import config from 'config'

const SplashScreen: FC = () => {
  const prefersDarkMode = useMedia('(prefers-color-scheme: dark)')
  const [theme] = useLocalStorage<string>(config.THEME_KEY, 'light')
  const [chameleonSkin] = useLocalStorage<ChameleonSkin | undefined>(config.SKIN_KEY, 'gotoadmin')
  const chameleonTheme: 'light' | 'dark' =
    theme === 'os' ? (prefersDarkMode ? 'dark' : 'light') : theme === 'dark' ? 'dark' : 'light'

  return (
    <ChamWebThemeProvider theme={chameleonTheme} skin={chameleonSkin} rebranding2021={true}>
      <LaunchScreen />
    </ChamWebThemeProvider>
  )
}
export default SplashScreen
